import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';

import Backend from '../Layouts/Backend';
import InfoboxFleet from './InfoboxFleet';
import ModalFormFleet from './ModalFormFleet';
import { actionCreators } from '../actionCreators';

class FleetsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalFleet: false,
      modalFleet: {},
    };

    this.createFleet = this.createFleet.bind(this);
    this.openModalNewFleet = this.openModalNewFleet.bind(this);
    this.hideModalNewFleet = this.hideModalNewFleet.bind(this);
  }

  createFleet(formData, key) {
    this.props.dispatch(actionCreators.createFleet(formData, key));
    this.hideModalNewFleet();
  }

  openModalNewFleet() {
    this.setState({
      modalFleet: {},
      showModalFleet: true,
    });
  }

  openModalEditFleet(fleet) {
    this.setState({
      modalFleet: { ...fleet },
      showModalFleet: true,
    });
  }

  hideModalNewFleet() {
    this.setState({
      showModalFleet: false,
    });
  }

  render() {
    const results = _.map(this.props.fleets, fleet => (
      <InfoboxFleet
        key={fleet.$key}
        fleet={fleet}
        onButtonClick={() => this.openModalEditFleet(fleet)}
      />
    ));

    return (
      <Backend>
        <div className="content-inner">
          <div className="filter form-inline">
            <a
              className="button button-default button-icon"
              style={{ float: 'left', marginRight: '10px' }}
              onClick={this.openModalNewFleet}
              onKeyPress={this.openModalNewFleet}
              role="button"
              tabIndex={0}
            >
              <i className="md-icon">add</i>
            </a>
            <form>
              <div className="form-group">
                <input type="text" className="form-control" placeholder="Buscar..." />
              </div>

              {results.length === 0 &&
                <div className="form-group form-group-description">
                  Ainda não existem Frotas cadastradas
                </div>
              }
            </form>
          </div>

          <div className="projects">{results}</div>

          <ModalFormFleet
            showModal={this.state.showModalFleet}
            fleet={this.state.modalFleet}
            onAccept={this.createFleet}
            onCancel={this.hideModalNewFleet}
          />

        </div>
      </Backend>
    );
  }
}

FleetsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fleets: PropTypes.array.isRequired,
};

export default connect((store) => {
  const fleets = _.map(_.get(store, 'fleetState.fleets', {}), (fleet, key) => ({
    $key: key,
    ...fleet,
  }));

  return { fleets };
})(FleetsPage);



// WEBPACK FOOTER //
// ./src/Fleet/FleetsPage.js